import React from 'react'
import PropTypes from 'prop-types'
import Shimmer from 'Components/shimmer'

const MaleDailyBannerShimmer = ({ isMobile }) => {
  const device = isMobile ? 'mobile' : 'desktop'
  return (
    <>
      <div
        className={`maledaily-banner-shimmer maledaily-banner-shimmer--${device}`}
      >
        <Shimmer
          width={isMobile ? '480px' : '1440px'}
          height={isMobile ? '480px' : '478px'}
        />
      </div>
      <style jsx>
        {`
          .maledaily-banner-shimmer {
            width: 100%;
            max-width: 1440px;
            margin: auto;
          }

          .maledaily-banner-shimmer--mobile {
            max-width: 480px;
          }
        `}
      </style>
    </>
  )
}

MaleDailyBannerShimmer.propTypes = {
  isMobile: PropTypes.bool,
}

export default MaleDailyBannerShimmer
